import React, { useState } from "react";
import { IoMdSearch } from "react-icons/io";

function InputSearch() {
  const [searchText, setSearchText] = useState("");

  return (
    <div
      className="group relative w-60 flex items-center justify-between  rounded-md px-3 shadow-sm border  border-gray-300 transition "
      style={{ paddingBottom: "2px", paddingTop: "2px" }}
    >
      <input
        type="text"
        placeholder="Search"
        className="bg-transparent outline-none border-none font-medium  text-gray-900 m-0 p-0  placeholder-gray-400"
        value={searchText}
        onChange={(e) => {
          const value = e.target.value;
          setSearchText(value);
        }}
      />
      <IoMdSearch size={22} className="text-gray-400 transition-colors" />
    </div>
  );
}

export default InputSearch;